const MAX_TITLE_LENGTH = 200;

interface TitleInputProps {
    value: string;
    onChange: (value: string) => void;
    disabled: boolean;
}

// A large "ghost" input - no border/box, reads as a headline rather than a
// form field, since the card around it is the only container it needs. The
// only field required to save.
export function TitleInput({ value, onChange, disabled }: TitleInputProps) {
    return (
        <input
            type="text"
            value={value}
            maxLength={MAX_TITLE_LENGTH}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            placeholder="What is this about?"
            className="w-full mt-1.5 p-0 border-0 bg-transparent text-[24px] font-bold text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-0 disabled:opacity-50"
        />
    );
}
